import { checkExperiment } from '../isAbExperiment';
import { ISerializableAppState } from '../../common/state';
import { offerTypeFromJsonQuery, isUrban } from '../category';

export const EXPERIMENT_NAME = 'audience_serp_light';

export function isInSerpLightGroup({ experiments, results: { jsonQuery } }: ISerializableAppState): boolean {
  const offerType = offerTypeFromJsonQuery(jsonQuery);

  return checkExperiment(experiments, EXPERIMENT_NAME, 1) && isUrban(offerType);
}
